<template>
    <div class="" :class="['checkbox checkbox-lg', { 'readonly' : readonly && !hideCbx }, {'checkbox-label-only' : hideCbx}]">
        <input type="checkbox" :id="htmlId" :checked="checked"  @change="updateValue($event)" :disabled="readonly"/>
        <img v-if="hideCbx" src="images/check.svg"/>
        <label :for="htmlId">{{ label }}</label>
    </div>
</template>

<script>
export default {
    props: {
        htmlId: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        checked: {
            type: Boolean,
            required: false
        },
        itemIndex : {
            type: Number,
            required : false,
            default : null
        },
        readonly: {
            type: Boolean,
            required: false,
            default : false
        },
        hideCbx: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        updateValue(e) {
            var mutationName = 'set' + this.htmlId
            if(this.itemIndex != null){
                mutationName = mutationName.replace("_" + this.itemIndex, "")
                var data = {index : this.itemIndex, value : e.target.checked };
                this.$store.commit(mutationName, data)
            }
            else
            {
                this.$store.commit(mutationName, e.target.checked)
            }
        }
    }
}
</script>